import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Longtrip, barrieri di lingua",
  "description": "",
  "published": "2013-08-05T00:00:00.000Z",
  "redirect_from": ["/blog/longtrip-barrieri-di-lingua/swizec/6301"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/rMAKmIaQQh2VxmdEZKJq",
        "alt": "Lago di Garda from our Berlingo",
        "title": "Lago di Garda from our Berlingo"
      }}></img><img parentName="p" {...{
        "src": "",
        "alt": null
      }}></img></p>
    <p>{`"No no, I said `}<em parentName="p">{`ice`}</em>{` not `}<em parentName="p">{`weiss`}</em>{`."`}</p>
    <p>{`I had ordered my usual summer drink - black tea with a large glass of ice - at a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gelato",
        "title": "Gelato"
      }}>{`gelateria`}</a>{` in a town called `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,9.3&spn=0.1,0.1&q=46.05,9.3%20(Bellano)&t=h",
        "title": "Bellano"
      }}>{`Bellano`}</a>{`. The waiter brought a cold glass of German Weiss bier.`}</p>
    <p>{`"Cosa?"`}</p>
    <p>{`"Ice! I want a glass of ice for my tea."`}</p>
    <p>{`"Errr … gelato?"`}</p>
    <p>{`He didn't speak German either. Most Italians in the touristy areas around `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0,9.26666666667&spn=0.1,0.1&q=46.0,9.26666666667%20(Lake%20Como)&t=h",
        "title": "Lake Como"
      }}>{`Lago di Como`}</a>{` and Lago di Garda speak German either because of the proximity of Switzerland or because most of the tourists speak German.`}</p>
    <p>{`English, not so much. But `}<em parentName="p">{`eis`}</em>{` and `}<em parentName="p">{`ice`}</em>{` sound the same so I'm guessing German was as foreign to this tattooed waiter as English.`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/tUgii1SoSY6z0tTJ8ywq",
        "alt": "Gelateria in Bellino",
        "title": "Gelateria in Bellino"
      }}></img></p>
    <p>{`Clearly not a very touristy area. There were barely any camps and most of the traffic on this side of the Lago di Como was Italian. At Garda most cars were from other countries.`}</p>
    <p>{`But hey, that's what you get when Kaylee, the GPS, encounters a twenty kilometer stretch of closed road and gets lost. Took us three hours to get from Bellano to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.1333333333,9.28333333333&spn=0.1,0.1&q=46.1333333333,9.28333333333%20(Dongo%2C%20Lombardy)&t=h",
        "title": "Dongo, Lombardy"
      }}>{`Dongo`}</a>{` - a distance of just fifty kilometers. Infinite if you don't know where to go.`}</p>
    <p>{`"No no, no gelato. Ice, ice! err … cold water?"`}</p>
    <p>{`"Ghiaccio?"`}</p>
    <p>{`"I don't know, eis. `}<em parentName="p">{`sygnals furiously with hands`}</em>{` Err … tiny cubes of water … aqua solido."`}</p>
    <p>{`"Si si, ghiaccio."`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/9THk5tmwR6O8vE2vMEJA",
        "alt": "There was also a very nice car",
        "title": "There was also a very nice car"
      }}></img></p>
    <p>{`Aqua solido worked. Good on `}<a parentName="p" {...{
        "href": "http://twitter.com/robertbasic"
      }}>{`@robertbasic`}</a>{` coming up with that. We had no idea what ghiaccio meant, but the waiter was very encouraging.`}</p>
    <p>{`"Errr … okay then, ghiaccio, si. A full glass of ghiaccio, preggo."`}</p>
    <p>{`Moments later the sunburnt waiter came back with a full glass of ice. Ghiaccio, have to keep that word in mind.`}</p>
    <p>{`That was the first time we hit the language barrier on this roadtrip around Europe. Running around Italy, `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=48.8566666667,2.35083333333&spn=10.0,10.0&q=48.8566666667,2.35083333333%20(France)&t=h",
        "title": "France"
      }}>{`France`}</a>{`, Spain, Portugal, Belgium and Germany like two lunatics equipped only with our native languages, English and fragments of German was a brilliant idea. I'm absolutely certain no more language barriers will be hit and from now on everyone will speak fluent English.`}</p>
    <p>{`Especially when we're longboarding up in the goat mountain roads where the serpentines are sharp and cars overheat. Everyone there is going to speak English right?`}</p>
    <p>{`When did I become one of those crappy American tourists that expects everyone everywhere to speak English anyway? It's not even my native language ...`}</p>
    <p>{`Oh well, onwards to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Millau",
        "title": "Millau"
      }}>{`Millau`}</a>{` at 7:30 tomorrow morning to see the tallest bridge in the world and then to a four day longboarding event at Maison de Peyragudes.`}</p>
    <p>{`Everyone in France speaks English right?`}</p>
    <p><img parentName="p" {...{
        "src": "https://www.filepicker.io/api/file/W9G0ao2QH2BE01syW42m",
        "alt": "Also, camp cooking is fun",
        "title": "Also, camp cooking is fun"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=05795a5f-ed53-42ba-80b0-e6920346a8bc",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      